import { Container } from '@mui/material';
import checkIcon from 'assets/icons/check.svg';
import { setCancelationModalOpen } from 'v3/data/store/cancellationNavigation/actions';
import { AlignIcon, Icon, Content, TitleSection } from 'v3/pages/OnlineContracting/Cancellation/styles';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { HeadlineSmall } from 'v3/shared/typography/HeadlineSmall';
import { SubtitleLarge } from 'v3/shared/typography/SubtitleLarge';
import { theme } from 'v3/styles/global-styles';

export const OrderCanceledSuccessfullyStep = () => {
  const handleConfirm = () => {
    setCancelationModalOpen(false);
  };

  return (
    <Content>
      <AlignIcon>
        <Icon src={checkIcon} alt="Success" />
      </AlignIcon>
      <TitleSection>
        <HeadlineSmall>Estamos analisando seu pedido</HeadlineSmall>
        <SubtitleLarge color={theme.palette.info.main}>
          Seu pedido de cancelamento está em análise. Atualize a página em alguns minutos para verifica o status
        </SubtitleLarge>
      </TitleSection>
      <Container>
        <FlexButton text="Certo, entendi" size="small" handleClick={handleConfirm} />
      </Container>
    </Content>
  );
};
